import XlsxPopulate from 'xlsx-populate';

const genCharArray = (charA, charZ) => {
  let a = [],
    i = charA.charCodeAt(0),
    j = charZ.charCodeAt(0);
  for (; i <= j; ++i) {
    a.push(String.fromCharCode(i).toUpperCase());
  }
  return a;
};

export const generateExcel = (data, fileName, header, headerChanging) => {
  XlsxPopulate.fromBlankAsync().then((workbook) => {
    workbook
      .sheet('Sheet1')
      .cell('A1')
      .value([
        header,
        ...data.map((elem) => {
          return headerChanging.reduce((accumulator, key) => {
            accumulator.push(elem[key]);
            return accumulator;
          }, []);
        }),
      ])
      .style({ fontSize: 10, fontFamily: 'Arial' });

    data.forEach((elem, id) => {
      if (elem.isReject) {
        workbook
          .sheet('Sheet1')
          .row(id + 2)
          .style('fill', {
            type: 'solid',
            color: {
              rgb: 'f8b5b4',
            },
          });
      }
    });

    genCharArray('a', 'h').forEach((elem) => {
      workbook.sheet('Sheet1').column(elem).width(30);
    });

    workbook
      .sheet('Sheet1')
      .row(1)
      .style({ bold: true })
      .style('fill', {
        type: 'solid',
        color: {
          rgb: 'fef2cd',
        },
      })
      .style('borderColor', '000000');

    workbook.outputAsync().then(function (blob) {
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'out.xlsx');
      } else {
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        document.body.appendChild(a);
        a.href = url;
        a.download = `${fileName}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      }
    });
  });
};
